import React from 'react';
import { motion } from 'framer-motion';

const Logo = () => {
  const logoUrl = "https://customer-assets.emergentagent.com/job_realtime-lucy/artifacts/iswmq32o_L.png";

  return (
    <motion.div
      className="flex items-center gap-3"
      initial={{ opacity: 0, x: -20 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.5 }}
      data-testid="app-brand"
    >
      {/* Logo with neon effects */}
      <div className="relative">
        {/* Outer glow ring */}
        <motion.div
          className="absolute inset-0 rounded-full"
          style={{
            background: 'radial-gradient(circle, rgba(6, 182, 212, 0.4) 0%, transparent 70%)',
            filter: 'blur(8px)',
            transform: 'scale(1.4)'
          }}
          animate={{
            opacity: [0.5, 0.8, 0.5]
          }}
          transition={{
            duration: 3,
            repeat: Infinity,
            ease: "easeInOut"
          }}
        />

        {/* Logo container */}
        <div className="relative w-12 h-12 rounded-full overflow-hidden border-2 bg-white flex items-center justify-center" style={{
          borderColor: 'var(--accent-cyan)',
          boxShadow: '0 0 20px rgba(6, 182, 212, 0.5)'
        }}>
          <img
            src={logoUrl}
            alt="Coach Life"
            className="w-10 h-10 object-contain"
          />
        </div>

        {/* Spinning ring decoration */}
        <motion.div
          className="absolute inset-0 rounded-full border-2 border-transparent"
          style={{
            borderTopColor: 'var(--accent-ocean)',
            borderRightColor: 'var(--accent-ocean)'
          }}
          animate={{
            rotate: 360
          }}
          transition={{
            duration: 8,
            repeat: Infinity,
            ease: "linear"
          }}
        />
      </div>

      {/* Brand text with gradient */}
      <div className="flex flex-col">
        <div className="flex items-baseline gap-2">
          <h1
            className="font-display text-2xl font-bold"
            style={{
              background: 'linear-gradient(135deg, var(--accent-cyan) 0%, var(--accent-ocean) 50%, var(--accent-mint) 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text',
              letterSpacing: '0.02em'
            }}
          >
            Coach Life
          </h1>
          <span
            className="text-xs font-semibold px-2 py-0.5 rounded-full"
            style={{
              background: 'rgba(6, 182, 212, 0.15)',
              color: 'var(--accent-cyan)',
              border: '1px solid rgba(6, 182, 212, 0.3)'
            }}
          >
            AI
          </span>
        </div>
      </div>

      {/* Decorative particles */}
      <div className="relative hidden md:block">
        {[...Array(3)].map((_, i) => (
          <motion.div
            key={i}
            className="absolute w-1 h-1 rounded-full"
            style={{
              background: i === 0 ? 'var(--accent-cyan)' : i === 1 ? 'var(--accent-ocean)' : 'var(--accent-mint)',
              left: `${i * 8}px`,
              top: '50%'
            }}
            animate={{
              y: [-10, 10, -10],
              opacity: [0.3, 1, 0.3]
            }}
            transition={{
              duration: 2 + i * 0.5,
              repeat: Infinity,
              ease: "easeInOut",
              delay: i * 0.3
            }}
          />
        ))}
      </div>
    </motion.div>
  );
};

export default Logo;
